import { LogoMark } from '@cbhq/cds-web/icons/LogoMark';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { TwoColumnLayout } from '../../layout/TwoColumnLayout.js';
import { CTAButtons } from '../../ui/CTAButtons.js';
import '../../ui/Div/index.js';
import { EmailOnlyUserForm } from '../../ui/Form/EmailOnlyUserForm.js';
import { LegalDisclaimer } from '../../ui/LegalDisclaimer.js';
import '../../ui/media/index.js';
import { createListRichTextOptions } from '../../ui/RichText/options/listRichTextOptions.js';
import { RichText } from '../../ui/RichText/RichText.js';
import { Text } from '../../ui/Text.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Media } from '../../ui/media/Lazymedia.js';
function HeroPrimaryContent({
  eyebrow,
  hasEyebrowIcon = false,
  headline,
  excerpt,
  list,
  legalText,
  ctaType = 'links',
  ctaButtonLabel,
  ctaButtonUrl,
  secondaryButtonLabel,
  secondaryButtonUrl,
  logos,
  successMessage,
  placeholder,
  submitButtonLabel,
  onSuccess,
  onSubmit,
  alignContent,
  layout,
  style
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    foregroundInlineLink = _componentsThemeMap$s.foregroundInlineLink;
  const titleContent = /*#__PURE__*/jsxs(Fragment, {
    children: [!!eyebrow && /*#__PURE__*/jsxs(Div, {
      css: {
        gap: '8px'
      },
      children: [hasEyebrowIcon && /*#__PURE__*/jsx(LogoMark, {
        size: 16
      }), /*#__PURE__*/jsx(Text, {
        variant: "label1",
        as: "p",
        color: foregroundSecondary,
        children: eyebrow
      })]
    }), /*#__PURE__*/jsx(Text, {
      variant: {
        sm: 'display2',
        lg: 'display1'
      },
      as: "h1",
      color: foreground,
      children: headline
    })]
  });
  const isForm = ctaType === 'form';
  const actionContent = isForm ? /*#__PURE__*/jsx(EmailOnlyUserForm, {
    submitButtonLabel: submitButtonLabel,
    successMessage: successMessage,
    placeholder: placeholder,
    onSuccess: onSuccess,
    onSubmit: onSubmit,
    style: style
  }) : /*#__PURE__*/jsx(CTAButtons, {
    ctaButtonLabel: ctaButtonLabel,
    ctaButtonUrl: ctaButtonUrl,
    secondaryButtonLabel: secondaryButtonLabel,
    secondaryButtonUrl: secondaryButtonUrl,
    contentBackground: background,
    foregroundInlineLink: foregroundInlineLink
  });
  const descriptionContent = /*#__PURE__*/jsxs(Fragment, {
    children: [excerpt && /*#__PURE__*/jsx(Text, {
      spacingTop: {
        sm: 1,
        md: 2,
        lg: 3
      },
      variant: {
        sm: 'body',
        lg: 'title2'
      },
      as: "p",
      color: foregroundSecondary,
      children: excerpt
    }), list && /*#__PURE__*/jsx(RichText, {
      content: list,
      richTextOptions: createListRichTextOptions(),
      color: foregroundSecondary,
      foregroundInlineLink: foregroundInlineLink
    }), actionContent, legalText && /*#__PURE__*/jsx(Div, {
      spacingTop: {
        sm: 3,
        lg: 5
      },
      flexDirection: "column",
      children: /*#__PURE__*/jsx(LegalDisclaimer, {
        legalDisclaimer: legalText,
        color: foregroundSecondary,
        foregroundInlineLink: foregroundInlineLink
      })
    }), logos && logos.length > 0 && /*#__PURE__*/jsx(Div, {
      spacingTop: {
        sm: 3,
        lg: 5
      },
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: 2,
      children: logos.map(logo => /*#__PURE__*/jsxs(Div, {
        flexDirection: "column",
        alignItems: "flex-start",
        width: {
          sm: '100%',
          md: 'auto'
        },
        spacingTop: 1,
        children: [logo.label && /*#__PURE__*/jsx(Text, {
          variant: "label2",
          as: "p",
          color: "foregroundMuted",
          children: logo.label
        }), /*#__PURE__*/jsxs(Div, {
          flexDirection: "row",
          alignItems: "center",
          children: [logo.imageUrl && /*#__PURE__*/jsx(Media, {
            mediaType: "image",
            src: logo.imageUrl,
            height: 36,
            imageFit: "contain"
          }), logo.title && /*#__PURE__*/jsx(Text, {
            variant: "body",
            as: "p",
            color: "foregroundMuted",
            children: logo.title
          })]
        })]
      }))
    })]
  });
  return /*#__PURE__*/jsx(SectionComponentLayout, {
    hasSpacingHorizontal: true,
    hasSpacingVertical: true,
    background: "transparent",
    children: layout === 'top' || layout === 'bottom' ? /*#__PURE__*/jsx(TwoColumnLayout, {
      mainContentPosition: "left",
      mainContent: /*#__PURE__*/jsx(Div, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: alignContent,
        flexGrow: 1,
        spacingVertical: 5,
        children: titleContent
      }),
      mainContentPercentage: 50,
      secondaryContent: /*#__PURE__*/jsx(Div, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: alignContent,
        flexGrow: 1,
        children: descriptionContent
      }),
      secondaryContentPercentage: 50
    }) : /*#__PURE__*/jsxs(Div, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: alignContent,
      flexGrow: 1,
      minHeight: {
        sm: 300,
        lg: 725
      },
      children: [titleContent, descriptionContent]
    })
  });
}
export { HeroPrimaryContent };
//# sourceMappingURL=HeroPrimaryContent.js.map
